var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-text-centered"},[_c('img',{staticClass:"jsb-logo",attrs:{"src":_vm.jsbLogoPath,"alt":_vm.jsbLogoAlt},on:{"load":_vm.logoLoaded}})])}
var staticRenderFns = []

export { render, staticRenderFns }